import { io, Socket } from 'socket.io-client';
import { storage } from './storage';

let socket: Socket | null = null;

/**
 * Socket.io 싱글톤 클라이언트
 * 인증 토큰은 handshake에 포함 (서버에서 선택적 검증)
 */
export function getSocket(): Socket {
  if (socket && socket.connected) return socket;

  socket = io('/', {
    path: '/socket.io',
    transports: ['websocket'],
    auth: {
      token: storage.get<string>('accessToken') ?? undefined,
    },
    reconnection: true,
    reconnectionDelay: 2000,
    reconnectionAttempts: 5,
  });

  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
